export function isInternalAppUrl(
  url: URL,
  currentHost: string,
  internalHosts: readonly string[],
): boolean {
  return url.protocol === 'hypris:'
    || internalHosts.includes(url.host)
    || url.host === currentHost
}
